import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-error404',
    templateUrl: './error404.component.html',
    styleUrls: ['./error404.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule]
})
export class Error404Component implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  goBack(): void {
    history.back();
  }
}
